<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">
      <template v-slot:activator="{ on }">
        <!-- <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name
        }}</v-btn> -->
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field data-vv-as="nombre" label="Nombre*" name="name" v-model="item.name"
                  v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>

                
                <v-combobox v-model="item.product_presentation" data-vv-as="Producto por defecto" name="product_presentation"
                item-text="label" item-value="id" :items="presentations" label="Producto por defecto"
                autocomplete="off" :disabled="isViewModal()"></v-combobox>
                
                <v-combobox v-model="item.storage_unit" data-vv-as="Unidad de almacenamiento" name="storage_unit"
                  item-text="name" item-value="id" :items="storage_units" label="Unidad de almacenamiento"
                  autocomplete="off" :disabled="isViewModal() || isStorageUnitDisabled"></v-combobox>
                <span class="red--text">{{ errors.first("storage_unit") }}</span>

              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";

import { generalService } from "@/libs/ws/generalService";
export default {
  mixins: [],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      show: false,
      loading: false,
      storage_units: [],
      presentations: []
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
    "item.product_presentation"(newValue, oldValue) {
      // Si se selecciona una presentación de producto
      if (newValue && newValue.storage_unit) {
        // Autocompletar el storage_unit con el de la presentación
        this.item.storage_unit = newValue.storage_unit;
      } else if (newValue === null || newValue === undefined) {
        // Si se limpia la presentación, limpiar también el storage_unit
        this.item.storage_unit = null;
      }
    },
  },
  computed: {
    isStorageUnitDisabled() {
      // Deshabilitar si hay una presentación de producto seleccionada
      return this.item.product_presentation !== null && this.item.product_presentation !== undefined;
    },
  },
  mounted() {
    this.loadComboData();
    this.loadPresentations();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },

    loadPresentations() {
      generalService
        .query({ buyable: true }, Constant.SECTION_PRODUCTS + "/presentations")
        .then((response) => {
          this.presentations = response.result;
        })
        .catch((e) => {
          console.log("presentations.filter error", e);
        });
    },
    loadComboData() {
      generalService.query({}, Constant.SECTION_UNITS + "/list_storage_units").then((response) => {
        this.storage_units = response.result;
      });
    },
    createItem(e) {
      if (this.loading) return;
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();

          this.loading = true;
          const data = {
            id: this.item.id,
            name: this.item.name,
            storage_unit: this.item.storage_unit,
            product_presentation: this.item.product_presentation,
          };

          if (this.item.id > 0) {
            this.service
              .update(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se modificó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          } else {
            this.service
              .create(data)
              .then((response) => {
                if (response.status == true) {
                  this.$toast.success("La " + this.modal_title + " se creó correctamente.", "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
                this.loading = false;
              })
              .catch((error) => {
                console.error(error);
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>
